/*
 * creates a comparator function which can be used together with
 * Array.prototype.sort assuming an array of objects which have at
 * least one numeric property which they can be sorted by
 *
 * supports ascending or descending order
 *
 *
 * ([ { age: 28 }, { age: 30 }, { age: 25 } ]).sort(createComparator('age', 'ascending')) -> [ { age: 25 }, { age: 28 }, { age: 30 } ]
 */

module.exports = function createComparator (property, order) {
  return function (
    { [ property ]: propertyA },
    { [ property ]: propertyB }
  ) {
    return order === 'ascending'
      ? propertyA - propertyB
      : propertyB - propertyA
  }
}
